import { useState, useEffect, useContext, useRef } from 'react'
import Draggable, {DraggableCore} from 'react-draggable';
import { useTranslation } from "react-i18next";

import './css/question.css'

import { AppContext } from "../../../Context";
import { Img, PlayAudio } from "../../../components/Elements";
import Like from "./like";
import { MdOutlineRadioButtonUnchecked, MdOutlineRadioButtonChecked, MdCheckBoxOutlineBlank, MdCheckBox, MdOutlineClose } from "react-icons/md";

import right from '../../../assets/right.png'
import wrong from '../../../assets/wrong.png'

export default function Question({data, show, k, response, showAnswers, print, st_answers, active}) {

    
    const { t } = useTranslation();
    const refC = useRef();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;
    
    const [dragAnswer, setdragAnswer] = useState("");
    const [answers, setanswers] = useState([]);
    const [inputList, setinputList] = useState([]);
    const [activate, setactivate] = useState(false);

    function unCheckAll() {
        var elems = document.querySelectorAll(".missingWordBox .selected");

        [].forEach.call(elems, function(el) {
            el.classList.remove("selected");
        });
    }

    function deleteDragable(elem) {

        let close = elem?.closest('inp');
        if (!close) return false;
        
        close.innerHTML='&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;'
        let id = close?.getAttribute("answer").replace("'", "");

        let selector = document.querySelector(`.tagsToDragFrom #${id}`);
        selector.style.display="block";

        close.removeAttribute('answer');

        
    }


    function saveDrop() {
        unCheckAll();
        
        if (dragAnswer.drop) {
            let dropID = dragAnswer.drop?.getAttribute('id');
            let dragID = dragAnswer.drag?.getAttribute('id');
            dragAnswer.drop.setAttribute("answer", dragID);
            // dragAnswer.drop.innerHTML = `<svg onClick="deleteDragable(this);" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg>${dragAnswer?.drag?.textContent}`;
            dragAnswer.drop.innerHTML = `<svg class='dragDeleteIcon' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"></path></svg>${dragAnswer?.drag?.textContent}`;
            dragAnswer.drag.style.display = "none";

            setanswers(p => ({
                ...p,
                [dragID]: dropID
            }));

            const elements = document.querySelectorAll(".dragDeleteIcon");
    
    
            elements.forEach((el) => el.addEventListener("click", handleClick));
    
            // Cleanup on unmount
            return () => {
                elements.forEach((el) => el.removeEventListener("click", handleClick));
            };
            
        }

        setdragAnswer("");

    }

    const handleClick = (e) => {
        deleteDragable(e?.target)
    };

    

    function selectQuestion(answer, k) {

        answer.type = data?.type;
        answer.k = k;

        setanswers(answer);
    }

    function checkQuestion(answer, k) {
        let ck = answers[k];
        
        if (ck) {
            setanswers(p => {

                let arr = {};
                Object.keys(p)?.map((v) => {

                    if (v != k) {
                        arr[v] = p[v]
                    }
                });
     
                return arr
            });
        } else {
            answer.type = data?.type;
            setanswers(p => ({
                ...p,
                [k]: answer
            }));
        }
    }

    function KidSownd({type}) {

        useEffect(() => {
            if (type == 1) {
                const audio = new Audio("/right.mp3");
                audio.play();
            } else {
                const audio = new Audio("/wrong.mp3");
                audio.play();
            }
        }, []);
        
        return (
            <div className='charectersBox'>
                <div className='charecters'>
                    {type == 1 && <img 
                        src={right}
                    />}
                    {type == 2 && 
                        <img 
                            src={wrong}
                        />
                    } 
                </div>

            </div>
        );
    }

    useEffect(() => {
        let parser = new DOMParser();
        const doc = parser.parseFromString(data?.answers?.text, 'text/html');
        const inp = doc.getElementsByTagName('inp');
        var inputList2 = Array.prototype.slice.call(inp);
        inputList2.sort(() => (Math.random() > 0.5) ? 1 : -1)
        setinputList(inputList2); 

    }, []);

    var timer = null;
    useEffect(() => {
        if (typeof response !== 'undefined') {
            response(answers);
        }

        if (active) {

            if (answers?.type == 2) {
                
                if (answers?.checked) {
                    setactivate(1);
                } else {
                    setactivate(2);
                }
            }
            if (answers && data?.type == 4) {
                let checked = data?.answers[answers];
                if (checked?.checked) {
                    setactivate(1);
                } else {
                    setactivate(2);
                }
            }

            

            timer = setTimeout(() => {
                if (answers && data?.type == 1) {

                    if (data?.answers?.text == answers) {
                        setactivate(1);
                    } else {
                        setactivate(2);
                    }

                }

                if (answers && data?.type == 3) {
                    
                    let ans = true;
                    Object.keys(answers)?.map(v => {
                        if (!answers[v]?.checked) {
                            ans = false;
                        }
                    });
                    if (ans) {
                        setactivate(1);
                    } else {
                        setactivate(2);
                    }

                }

            }, 1000);
            
            setTimeout(() => {
                setactivate(false);
            }, 3000);
        }

        return () => {
            clearTimeout(timer);
        };
        
    }, [answers]);


    return (
        <>

        {activate && <KidSownd type={activate} />}

        <div className={`quizBox ${show ? "show" : "none"}`}>

            {st_answers?.note ? <div className='teacherNotesBox'><b>{t("tasks_send_notes")}: </b> {st_answers?.note}</div>: false}

            <div className='questBox'>
                <div className='flex'>
                    <b>{k + 1}.</b>
                    <div className='questionB' dangerouslySetInnerHTML={{ __html: data?.question }}></div>
                </div>

                <Like id={data?.id} />
            </div>
           
            
            {data?.type == 1 && 

                <div className='answerTextBox'>
                    <textarea disabled={st_answers?.answer ? true : false} onChange={(d) => setanswers(d.target.value)} className='answer_text' value={st_answers?.answer ? st_answers?.answer : showAnswers ? data?.answers?.text : answers}></textarea>
                </div>
            }
            {data?.type == 2 && 
                <div className='answersBox'>
                    {data?.answers?.map((v, k) => {

                        let selected = false;
                        if (answers?.k == k ) {
                            selected = true;
                        }
                        
                        if (showAnswers) {
                            selected = false;
                            if (data?.answers[k]?.checked ) { 
                                selected = true;
                            }
                        }

                        let classAddRight = "";
                        if (st_answers?.answer?.answer) {
                            if (k == st_answers?.answer?.k) {
                                selected = true;
                            }

                            if (data?.answers[k]?.checked ) { 
                                classAddRight = "right";
                            }
                            // console.log("aaa");
                            
                        }
                        
                        let ext = !v?.img ? false : v?.img?.split(".")?.pop();
                        
                        return (
                            <a className={`${classAddRight} ${selected && "ck"} ${ext ? "mediaQuestion" : "null"}`} tabIndex="0" onKeyDown={(e) => { if (e.key === 'Enter') {  st_answers?.answer ? false : selectQuestion(v, k) } }} onClick={() => st_answers?.answer ? false : selectQuestion(v, k)}>
                                {print ? 
                                    <>
                                        <MdCheckBoxOutlineBlank />
                                        {/* {v?.img && <Img src={v?.img} />} */}
                                        <span>{v?.answer}</span>
                                    </>
                                :
                                <>
                                    {v?.img ? 
                                    <>
                                        {ext == "mp3" ? 
                                            <PlayAudio file={v?.img}/>
                                        :
                                            <Img src={v?.img} />
                                        }
                                    </>
                                    :
                                    <>
                                        {selected ?
                                            <MdOutlineRadioButtonChecked />
                                        :
                                            <MdOutlineRadioButtonUnchecked />
                                        }
                                    </>
                                    }
                                </>
                                }
                                
                                <span>{v?.answer}</span>
                            </a>
                        );
                    })}
                    

                </div>
            }
            {data?.type == 3 && 
                <div className='answersBox'>

                    {data?.answers?.map((v, k) => {

                        let ck = answers[k];

                        if (showAnswers) {
                            ck = false;
                            if (data?.answers[k]?.checked) {
                                ck = true;
                            }
                            
                        }
                        
                        let classAddRight = "";
                        if (st_answers?.answer) {
                            if (st_answers?.answer[k]) {
                                ck = true;
                            }

                            if (data?.answers[k]?.checked ) { 
                                classAddRight = "right";
                            }

                        }

                        if (print) {
                            return (
                                <a className={`${classAddRight} ${ck ? "ck" : "none"}`} onClick={() => st_answers?.answer ? false : checkQuestion(v, k)}>
                                    <MdCheckBoxOutlineBlank />
                                    {v?.img && <Img src={v?.img} />}
                                    
                                    <span>{v?.answer}</span>
                                </a>
                            );
                        } else {
                            return (
                                <a className={ck ? "ck" : "none"} onClick={() => st_answers?.answer ? false : checkQuestion(v, k)}>
                                    {v?.img ? <Img src={v?.img} /> :
                                    <>
                                        {ck ?
                                            <MdCheckBox />
                                        :
                                            <MdCheckBoxOutlineBlank />
                                        }
                                    </>
                                    }
                   
                                    <span>{v?.answer}</span>
                                </a>
                            );
                        }
                        
                    })}

                   

                </div>
            }
            {data?.type == 4 && 
                <div className='answersBox'>
                    
                    {print ? 
                        <>
                            {data?.answers?.map((v, k) => {
                                return (
                                    <a>
                                        <MdCheckBoxOutlineBlank />
                                        {v?.img && <Img src={v?.img} />}
                                        <span>{v?.answer}</span>
                                    </a>
                                );
                            })}
                        </>
                    : <select disabled={st_answers?.answer ? true : false} onChange={(d) => setanswers(d?.target?.value)} className='selectBoxAnswer'>
                        <option value="">--</option>
                        {data?.answers?.map((v, k) => {

                            let selected = false;
                            if (showAnswers) {
                                if (v?.checked) {
                                    selected = true;
                                }
                            }

                            if (st_answers?.answer) {
               
                                if (st_answers?.answer?.length && st_answers?.answer == k) {
                                    selected = true;
                                }
                                
                            }

                            return (
                                <option selected={selected} value={k}>{v?.answer}</option>
                            );
                        })}
                        
                    </select>}

                </div>
            }

    
            {
                (() => {
                    if (data?.type == 5) {
                        
                        
                        let html = data?.answers?.text?.replace(/<inp(.*?)>(.*?)<\/inp>/g, '<inp$1>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</inp>');
                        if (showAnswers) {
                            html = data?.answers?.text;
                        }

                        if (st_answers?.answer) {

                            html = data?.answers?.text?.replace(/<inp id=\"(.*?)\">(.*?)<\/inp>/g, (match, offset) => {
                                // console.log(offset); 
                                
                                let id = st_answers?.answer ? st_answers?.answer[offset] : false;
                                let rep = ""; 
                   
                                inputList?.map((v, k) => {
                                    
                                    if (v?.getAttribute('id') == id){
                                        rep = v.textContent || v.innerText
                                    }
                                    
                                });

                                return `<inp id="${id}">${rep}</inp>`
                                
                            });
                            
  
                        }
                        
                        function findElement(d) {
                            let elem = document?.elementsFromPoint(d?.clientX, d?.clientY);

                            unCheckAll();

                            if (elem[1]?.tagName == "INP") {
                                
                                let drag = elem[0]?.getAttribute('id');
                                let drop = elem[1]?.getAttribute('id');
                                elem[1]?.classList.add("selected");
                         
                                setdragAnswer({ drag:elem[0], drop:elem[1] });
                            }
                            
                        }
                        
                        return (
                            <div>
                                <div className='missingWordBox'  id='fullText' dangerouslySetInnerHTML={{ __html: html }}></div>
                                {!showAnswers && !st_answers?.answer ? <div className='tagsToDragFrom' >
                                    {inputList?.map((v, k) => {
                    
                                        let id = v?.getAttribute('id');
                                        
                                        return (
                                            <Draggable
                                                // axis="x"
                                                handle=".handle"
                                                defaultPosition={{x: 0, y: 0}}
                                                position={{x: 0, y: 0}}
                                                // grid={[25, 25]}
                                                scale={1}
                                                // onStart={(d) => console.log(d)}
                                                onDrag={findElement}
                                                onStop={saveDrop}
                                            >
                                                <span id={id} className='handle'>{v.textContent || v.innerText}</span>
                                            </Draggable>
                                        );
                                    })}
                                </div>: false}
                            </div>
                            
                        );
                    }
                    
                })()
            }



            {
                (() => {

                    // if (showAnswers) {
                        
                    // }
  
                    if (data?.type == 6) {
                        
                        if (st_answers?.answer) {

                            document.querySelectorAll(`#d-${data?.id} .fractionInputVal`).forEach(e => {
                                let inp = e?.getAttribute('data-type');
                                if (inp == 'x') {
    
                                    let andCkFrac = st_answers?.answer?.filter(r => r?.type == 'x');
                                    if (andCkFrac?.length) {
                                        e.value = andCkFrac[0]?.value;
                                    }
              
                                }
                                if (inp == 'y') {
    
                                    let andCkFracy = st_answers?.answer?.filter(r => r?.type == 'y');
                                    if (andCkFracy?.length) {
                                        e.value = andCkFracy[0]?.value;
                                    }
                                    
                                }
    
                                if (inp == 'z') {
    
                                    let andCkFracy = st_answers?.answer?.filter(r => r?.type == 'z');
                                    if (andCkFracy?.length) {
                                        e.value = andCkFracy[0]?.value;
                                    }
                                    
                                }
                                
                            });
                        }
                        
                        let answer = "";
                        let disabled = "";
                        if (st_answers?.answer) {
                            disabled = "disabled";
                        }

                        let html = data?.answers?.math?.replace(/<spaninput(.*?)>(.*?)<\/spaninput>/g, `<input value="${showAnswers ? "$2" : answer}" class='fractionInputVal' ${disabled} data-id="${data?.id}" data-answer="$2" $1></input>`);

                        return (
                            <div className={`fractionBoxFull`} id={`d-${data?.id}`} dangerouslySetInnerHTML={{ __html: html }}></div>
                        );
                    }
                    
                })()
            }
                
        </div>
        </>
    );
}
